import axios from "axios";
const NO_ADS = "NO_ADS";
const NO_ADS_SUPPORTED = "NO_ADS_SUPPORTED";
const AD_BLOCKER_DETECTED = "AD_BLOCKER_DETECTED";
const PARSING_ADS_ERROR = "PARSING_ADS_ERROR";
const NO_PARSABLE_ADS = "NO_PARSABLE_ADS";
const ENCRYPTED = "CRYPTED";
const PARENTAL_CODE_REQUIRED = "PARENTAL-CODE-REQUIRED";
const PARENTAL_RATING_RESTRICTED_HOURS = "PARENTAL-RATING-RESTRICTED-HOURS";
const UNAUTHORIZED_PARENTAL_RATING = "UNAUTHORIZED-PARENTAL-RATING";
const UNAUTHORIZED_RATING = "UNAUTHORIZED_RATING";
const PARENTAL_RATING_RESTRICTED_DEVICE = "PARENTAL-RATING-RESTRICTED-DEVICE";
const MEDIA_ERROR = "MEDIA_ERROR";
const ERROR_FROM_CORE_PLAYER = "ERROR_FROM_CORE_PLAYER";
const FAILED_LOADED_WITH_UHD_PLAYSET = "FAILED_LOADED_WITH_UHD_PLAYSET";
const UNAUTHORIZED_LIVE = "UNAUTHORIZED-LIVE";
const UNAUTHORIZED_STARTOVER = "UNAUTHORIZED-STARTOVER";
const UNAUTHORIZED_CHANNEL = "UNAUTHORIZED-CHANNEL";
const LIVE_RESTRICTED_DEVICE = "LIVE-RESTRICTED-DEVICE";
const MULTI_UNAUTHORIZED_CONTENT = "MULTI_UNAUTHORIZED_CONTENT";
const NO_STREAM_ERROR_CODES = [
    ENCRYPTED,
    PARENTAL_CODE_REQUIRED,
    PARENTAL_RATING_RESTRICTED_HOURS,
];
let ErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    NO_ADS: NO_ADS,
    NO_ADS_SUPPORTED: NO_ADS_SUPPORTED,
    AD_BLOCKER_DETECTED: AD_BLOCKER_DETECTED,
    PARSING_ADS_ERROR: PARSING_ADS_ERROR,
    NO_PARSABLE_ADS: NO_PARSABLE_ADS,
    ENCRYPTED: ENCRYPTED,
    PARENTAL_CODE_REQUIRED: PARENTAL_CODE_REQUIRED,
    PARENTAL_RATING_RESTRICTED_HOURS: PARENTAL_RATING_RESTRICTED_HOURS,
    UNAUTHORIZED_PARENTAL_RATING: UNAUTHORIZED_PARENTAL_RATING,
    UNAUTHORIZED_RATING: UNAUTHORIZED_RATING,
    PARENTAL_RATING_RESTRICTED_DEVICE: PARENTAL_RATING_RESTRICTED_DEVICE,
    MEDIA_ERROR: MEDIA_ERROR,
    ERROR_FROM_CORE_PLAYER: ERROR_FROM_CORE_PLAYER,
    FAILED_LOADED_WITH_UHD_PLAYSET: FAILED_LOADED_WITH_UHD_PLAYSET,
    UNAUTHORIZED_LIVE: UNAUTHORIZED_LIVE,
    UNAUTHORIZED_STARTOVER: UNAUTHORIZED_STARTOVER,
    UNAUTHORIZED_CHANNEL: UNAUTHORIZED_CHANNEL,
    LIVE_RESTRICTED_DEVICE: LIVE_RESTRICTED_DEVICE,
    MULTI_UNAUTHORIZED_CONTENT: MULTI_UNAUTHORIZED_CONTENT,
    NO_STREAM_ERROR_CODES: NO_STREAM_ERROR_CODES
});

/* eslint-disable no-console */
class Logger {
    constructor() {
        this.defaultLevel = 5;
        this.LEVELS = {
            LOG: 0,
            DEBUG: 1,
            INFO: 2,
            WARN: 3,
            ERROR: 4,
            OFF: 5,
        };
        this.currentLevel = this.defaultLevel;
        this.warnedMessage = [];
    }
    static get instance() {
        if (!this.singleton) {
            console.debug("Logger > new instance");
            this.singleton = new Logger();
        }
        return this.singleton;
    }
    setLevel(value) {
        if (typeof value === "string") {
            this.currentLevel =
                this.LEVELS[value];
        } else if (typeof value === "number") {
            this.currentLevel = value;
        }
    }
    isEnabled(level) {
        return level >= this.currentLevel;
    }
    debug(msg, ...args) {
        const {
            DEBUG
        } = this.LEVELS;
        if (this.isEnabled(DEBUG)) {
            console.debug(msg, ...args);
        }
    }
    info(msg, ...args) {
        const {
            INFO
        } = this.LEVELS;
        if (this.isEnabled(INFO)) {
            console.info(msg, ...args);
        }
    }
    /**
     * Warn the user when the level of log is set to WARN.
     * If u want to warn and got rid of the level of authorize,
     * u can use warnOnce, useful to deliver message through our app to our
     * developer user.
     *
     * @param msg
     * @param args
     */
    warn(msg, ...args) {
        const {
            WARN
        } = this.LEVELS;
        if (this.isEnabled(WARN)) {
            console.warn(msg, ...args);
        }
    }
    /**
     * Warn user about a given message, but got rid of level of LOG.
     * This gives possibility to display message in PROD mode.
     * Usefull to give message to ppl that integrate us, because they will always
     * be using the PROD env where the LOG are disabled.
     * /!\ Will only warn user once during the life time of the application.
     *
     * @param msg
     * @param args
     */
    error(msg, ...args) {
        const {
            ERROR
        } = this.LEVELS;
        if (this.isEnabled(ERROR)) {
            console.error(msg, ...args);
        }
    }
}
const logger = Logger.instance;
// Firefox 1.0+
// Internet Explorer 6-11
const WIDEVINE_KEYSYSTEM = "com.widevine.alpha";
const FAIRPLAY_SYSTEM = "com.apple.fps.1_0";
const WIDEVINE = "widevine";
const PLAYREADY = "playready";
const FAIRPLAY = "fairplay";

const DRMTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WIDEVINE_KEYSYSTEM: WIDEVINE_KEYSYSTEM,
    FAIRPLAY_KEYSYSTEM: FAIRPLAY_SYSTEM,
    WIDEVINE: WIDEVINE,
    PLAYREADY: PLAYREADY,
    FAIRPLAY: FAIRPLAY
});

const isWindows = () => navigator.userAgent.indexOf("Windows") !== -1 ||
    navigator.userAgent.indexOf("Win64") !== -1;
const isIE = () =>
    /* @cc_on!@ */
    ("documentMode" in window);
// Edge Chromium
const isEdgeChromium = () => navigator.userAgent.indexOf("Chrome/") !== -1 &&
    navigator.userAgent.indexOf("Edg/") !== -1;
// Edge 20+
const isEdge = () => !isIE() && !isEdgeChromium() && ("StyleMedia" in window);
// Windows

const WIDEVINE_ROBUSTNESS = [
    "HW_SECURE_ALL",
    "HW_SECURE_DECODE",
    "HW_SECURE_CRYPTO",
    "SW_SECURE_DECODE",
    "SW_SECURE_CRYPTO",
]
const singleLicensePerInitData = "init-data";
const singleLicensePerPeriods = "periods";

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new(P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }

        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }

        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

/**
 * @description Fetch the reference for the specific context regards context/offerZone
 * @param arg0 - params
 * @param arg0.context channel to be used as context (eg. mycanal, mycanalcos..)
 * @param arg0.offerZone the zone of the user (eg. cpafra, cppol..)
 * @param arg0.domainName the url where we fetch the config (localhost or prod)
 * @returns the correct context name as a string
 */
function fetchContext({
                          context,
                          domainName,
                          offerZone,
                      }) {

    domainName = "https://player.canalplus.com/one/configs/v2/11"
    offerZone ="cpfa"

    return __awaiter(this, void 0, void 0, function*() {
        const configMapping = `https://${domainName}/mapping/mapping.json`;
        const {
            data: mapping
        } = yield axios.get(configMapping);
        const mappedCtx = context && mapping[context];
        if (mappedCtx === undefined || typeof mappedCtx === "string") {
            return {
                context: mapping.default
            };
        }
        const mappedCtxOfferZone = mappedCtx[offerZone];
        if (mappedCtxOfferZone === undefined) {
            return {
                context: mappedCtx.default,
                specific: mappedCtx.specific
            };
        }
        return {
            context: mappedCtxOfferZone,
            specific: mappedCtx.specific
        };
    });
}

/**
 * From string to js bytes array
 * @param str
 */
function strToBytes(str) {
    const len = str.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i += 1) {
        /* eslint-disable-next-line no-bitwise */
        arr[i] = str.charCodeAt(i) & 0xff;
    }
    return arr;
}
/**
 * From js bytes array to string
 *
 * @param bytes
 */
function bytesToStr(bytes) {
    return String.fromCharCode.apply(null, bytes);
}
/**
 * From js bytes array to string UTF 16
 * @param bytes
 */
function bytesToUTF16Str(bytes) {
    let str = "";
    const len = bytes.length;
    for (let i = 0; i < len; i += 2) {
        str += String.fromCharCode(bytes[i]);
    }
    return str;
}

function ensureHttpsOnUrl(url) {
    return typeof url === "string" ? url.replace(/^http:\/\//i, "https://") : "";
}
/**
 * Takes a string and remove his `http://`
 *
 * @export
 * @param {string} str
 * @returns {string} string without http
 */
function removeProtocolFromUrl(str) {
    return typeof str === "string" ? str.replace(/(^\w+:|^)\/\//, "") : "";
}
/**
 * @name removeEmptySegmentsFromUrl
 * @description remove empty segments inside url and return a clean url with https protocol
 * @param {string} url the url to clean
 * @returns {string}
 */
const removeEmptySegmentsFromUrl = (url) => {
    const cleanUrlWithoutHttp = removeProtocolFromUrl(url).replace(/\/+/g, "/");
    return "https://".concat(cleanUrlWithoutHttp);
};
/**
 * Takes a string with templated value
 * and returns a string with the correct values instead of the templates.
 * @export
 * @param {string} str // string with templated values
 * @param {object} templateContext // data to use to fill the templated values
 * @returns {string} string with correct values instead of templates
 */
function template(str, templateContext) {
    if (str === "" || typeof str !== "string") {
        return "";
    }
    const reTemplate = /{([\s\S]+?)}/g;
    const ternaryTemplate = /([\s\S]+?) \? ([\s\S]+?) : ([\s\S]+?)$/g;
    const quoteTemplate = /^".*"$/g;
    // replace every occurrence of "{*}" with the corresponding value
    return str.replace(reTemplate, (_, submatch) => {
        const [fullResult, conditionValue, valueTrue, valueFalse] = ternaryTemplate.exec(submatch) || [];
        // no ternary expression detected.
        // Returns the value associated with submatch in templateContext.
        if (!fullResult) {
            const templated = templateContext[submatch];
            return templated != null ? templated.toString() : "";
        }
        // The submatch looks like "x ? y : z"
        // and templateContext[x] is true.
        if (templateContext[conditionValue]) {
            // return y if it is a string  (quoted), otherwise return templateContext[y]
            if (quoteTemplate.test(valueTrue)) {
                return valueTrue.replace(/"+/g, "");
            }
            const templated = templateContext[valueTrue];
            return templated != null ? templated.toString() : "";
        }
        // The submatch looks like "x ? y : z"
        // and templateContext[x] is false.
        // return x if it is a string (quoted), otherwise return templateContext[x]
        if (quoteTemplate.test(valueFalse)) {
            return valueFalse.replace(/"+/g, "");
        }
        const templated = templateContext[valueFalse];
        return templated != null ? templated.toString() : "";
    });
}
/**
 * Fetch a live license thanks to a challenge.
 *
 * @param challenge
 * @param options
 * @returns A promise containing the license under a string format
 */

let DEFAULT_OFFER_ZONE ="cpfra"
const MKPL ="MKPL"
const SKPL ="SKPL"
function fetchLiveLicense(challenge, drmType, options) {

    const {
        FAIRPLAY
    } = DRMTypes;
    const {
        userProfile,
        epgId,
        config
    } = options;
    const url = removeEmptySegmentsFromUrl(template(config.licence, {
        drmId: config.drmId,
        offerZone: config.offerZone || DEFAULT_OFFER_ZONE,
        offerLocation: config.offerLocation || "",
    }));
    const mode = config.keyPerLicense === "mkpl" ? MKPL : SKPL;
    const body = {

        ServiceRequest: {
            InData: {
                EpgId: epgId,
                LiveToken: userProfile.liveToken,
                UserKeyId: userProfile.userKeyId,
                DeviceKeyId: userProfile.deviceKeyId,
                PersistentLicense: "false",
                ChallengeInfo: challenge,
                Mode: drmType !== FAIRPLAY ? mode : SKPL,
            },
        },
    };
    return axios.post(url, body).then((response) => {

        const {
            OutData,
            Status
        } = response.data.ServiceResponse;
        if (OutData === undefined) {
            const {
                ERROR_FROM_CORE_PLAYER
            } = ErrorCodes;
            const error = {
                code: `DRM${Status}`,
                message: `${ERROR_FROM_CORE_PLAYER};DRM${Status};no licence given mincessss`,
            };
            logger.error("One Player Core > fetchLicence throw an error", error);
            throw error;
        }
        return OutData.LicenseInfo;
    });
}

/*
 * @description create all keySystems for live content
 * @param drmOptions drm options required to create key systems
 * @param options other options necessary for license call
 * @returns key system for live platform
 */
function createLiveKeySystems(drmOptions, options) {

    const {
        keySystem,
        drmEnv
    } = drmOptions;
    const {
        config
    } = options;
    return Object.assign(Object.assign(Object.assign(Object.assign({
        type: keySystem,
        videoCapabilitiesConfig: {
            type: "robustness",
            value: getDRAMRobustness(keySystem),
        },
        audioCapabilitiesConfig: {
            type: "robustness",
            value: getDRAMRobustness(keySystem),
        },

        serverCertificate: config.drmCertificate,
        singleLicensePer: getSingleLicensePer(config.keyPerLicense, drmEnv, "live")
    }, ([
        "com.microsoft.playready.recommendation.esvm",
        "com.microsoft.playready.recommendation.3000",
        "com.microsoft.playready.recommendation.2000",
        "com.microsoft.playready.recommendation",
        "com.widevine.alpha",
    ].includes(keySystem) && {
        distinctiveIdentifier: "required",
    })), (config.shouldPersistLicense && [
        "com.microsoft.playready",
        "com.microsoft.playready.recommendation",
        "com.microsoft.playready.recommendation.esvm",
        "com.microsoft.playready.recommendation.3000",
        "com.microsoft.playready.recommendation.2000",
        "com.microsoft.playready.hardware",
        "com.microsoft.playready.software",
        "com.widevine.alpha",
    ].includes(keySystem) && {
        persistentLicenseConfig: {
            save(data) {
                localStorage.setItem("RxPlayer-licenseStorage", JSON.stringify(data));
            },
            load() {
                const item = localStorage.getItem("RxPlayer-licenseStorage");
                return item != null ? JSON.parse(item) : undefined;
            },
        },
        disableRetroCompatibility: true,
    })), (!config.shouldPersistLicense && [
        "com.microsoft.playready.recommendation.esvm",
        "com.microsoft.playready.recommendation.3000",
        "com.microsoft.playready.recommendation.2000",
        "com.microsoft.playready.recommendation",
        "com.widevine.alpha",
    ].includes(keySystem) && {
        persistentLicenseConfig: {
            /* eslint-disable-next-line */
            save() {},
            load() {
                return [];
            },
        },
    })), {
        onKeyInternalError: "fallback",
        onKeyOutputRestricted: "fallback",
        fallbackOn: {
            keyOutputRestricted: true,
            keyInternalError: true,
        },
        getLicense(challenge) {
            const formattedChallenge = formatChallenge(challenge, drmEnv);
            return fetchLiveLicense(formattedChallenge, drmEnv, options)
                .then((license) => extractLicense(license, drmEnv))
                .catch((err) => {
                    /**
                     * We get DRM-7 error code from MDRM license server that tell that we cant
                     * play the current video quality given our current security in our environment
                     */
                    const error = new Error(err.message);
                    const errorWithMKPC = Object.assign(error, {
                        code: err.code,
                        noRetry: err.code === 'DRM-7',
                        fallbackOnLastTry: err.code === 'DRM-7',
                    });
                    return Promise.reject(errorWithMKPC);
                });
        }
    });
}



/**
 * @param mimeType appropriate mime-type for the media
 * @returns convert mimeType to Drm Name
 */
function keySystemToDrmName(mimeType) {
    const DRM_MIME_TYPES_MAP = {
        "com.widevine.alpha": WIDEVINE,
        "com.microsoft.playready.software": PLAYREADY,
        "com.microsoft.playready.hardware": PLAYREADY,
        "com.microsoft.playready.recommendation.esvm": PLAYREADY,
        "com.microsoft.playready.recommendation.3000": PLAYREADY,
        "com.microsoft.playready.recommendation": PLAYREADY,
        "com.microsoft.playready.recommendation.2000": PLAYREADY,
        "com.microsoft.playready": PLAYREADY,
        "com.apple.fps.1_0": FAIRPLAY,
    };
    return DRM_MIME_TYPES_MAP[mimeType];
}

/**
 *
 * @param keyPerLicense type of key per License
 * @param drmEnv name of DRM environment
 * @param platform type of content we play
 * @returns get single License per periods or per init data
 */
function getSingleLicensePer(keyPerLicense = "skpl", drmEnv, platform) {

    if (drmEnv !== FAIRPLAY &&
        !(isWindows() && isEdgeChromium()) &&
        keyPerLicense === "mkpl") {
        return singleLicensePerPeriods;
    }
    return singleLicensePerInitData;
}
/**
 * @description create and get live key systems to pass to the core player
 * @param epgId id of the live channel
 * @param userProfile info about the user
 * @param config options to create live key systems
 * @returns array of key systems for live platform
 */
 function getLiveKeySystems(epgId, userProfile, config) {

     // If no drm are supported on the current environment, just return undefined,
    // instead of creating a keySystem option with null as keySystem type.
    if (config.supportedDrms === null) {
        return undefined;
    }
    return config.supportedDrms.map((drm) => createLiveKeySystems({
        keySystem: drm.keySystem,
        drmEnv: drm.name
    }, {
        epgId,
        userProfile,
        config,
    }));
}

// Robustness's used by playready
const PLAYREADY_ROBUSTNESS = ["3000", "2000"];
/**
 * We only need robustness's on widevine CDM
 * @param keySystem option allowing to communicate your decryption-related preferences
 * @returns string[]
 */
function getDRAMRobustness(keySystem) {
    const keySystemName = keySystemToDrmName(keySystem);
    if (keySystemName === "widevine") {
        return WIDEVINE_ROBUSTNESS;
    }
    if (keySystem === "com.microsoft.playready.recommendation") {
        return PLAYREADY_ROBUSTNESS;
    }
    if (keySystem === "com.apple.fps.1_0") {
        return PLAYREADY_ROBUSTNESS;
    }
    return [undefined];
}


/**
 * Retrieve the hash of the license inside a xml node that comes from HAPI webservice
 * @param xml
 * @param cdmType
 * @returns The hash license or null if not found
 */
function getHapiLicenseHash(xml, cdmType) {
    const CDM_TO_LICENSE = {
        widevine: /<license\b[^>]*>(.*)<\/license>/i,
        playready: /<clientresponse\b[^>]*>(.*)<\/clientresponse>/i,
        fairplay: /<clientresponse\b[^>]*>(.*)<\/clientresponse>/i,
    };
    const license = CDM_TO_LICENSE[cdmType].exec(xml);
    if (license !== null && license.length >= 2) {
        return license[1]; // Take the match returned by exec, the data we found inside xml node
    }
    return null;
}
/**
 * Take a Uint8Array binary challenge and transform it to a string that can be send through HTTP
 * For WIDEVINE Challenge
 * @param challenge
 * @returns The formatted challenge in string format
 */
function formatWidevineFairplayChallenge(challenge) {
    return btoa(bytesToStr(challenge));
}
/**
 * Take a Uint8Array binary challenge and transform it to a string that can be send through HTTP
 * For PLAYREADY Challenge
 * @param challenge
 * @returns The formatted challenge in string format
 */
function formatPlayreadyChallenge(challenge) {
    const str = bytesToUTF16Str(challenge);
    const match = /<Challenge encoding="base64encoded">(.*)<\/Challenge>/.exec(str);
    let challengeStr;
    if (match !== null && match.length >= 2) {
        // IE11 / EDGE
        challengeStr = atob(match[1]);
    } else {
        // Chromecast
        challengeStr = bytesToStr(new Uint8Array(challenge));
    }
    return challengeStr.replace("<?xml version='1.0' encoding='utf-8'?>", "");
}

/**
 * Gather the different way to format a challenge depending of the CDM used
 * WIDEVINE,PLAYREADY and FAIRPLAY supported
 * @param challenge
 * @param cdmType
 * @returns The formatted challenge depending of the CDM
 */
function formatChallenge(challenge, cdmType) {
    const CDM_TO_CHALLENGE_FORMAT = {
        widevine: formatWidevineFairplayChallenge(challenge),
        playready: formatPlayreadyChallenge(challenge),
        fairplay: formatWidevineFairplayChallenge(challenge),
    };
    return CDM_TO_CHALLENGE_FORMAT[cdmType];
}

/**
 * Assert if video is in fullscreen mode
 * @return {boolean}
 */
function isFullscreen() {
    const documentTyped = document;
    return !!(document.fullscreenElement ||
        documentTyped.mozFullScreenElement ||
        documentTyped.webkitFullscreenElement ||
        documentTyped.msFullscreenElement);
}

/**
 * Take a license representation encoded as a string and convert it as a Uint8Array binary format
 * to be able to inject it inside the CDM.
 * For WIDEVINE license
 * @param license
 * @returns The license as Binary
 */
function extractWidevineFairplayLicense(license) {
    return strToBytes(atob(license));
}

/**
 * Take a license representation encoded as a string and convert it as a Uint8Array binary format
 * to be able to inject it inside the CDM.
 * For PLAYREADY license
 * @param license
 * @returns The license as Binary
 */
function extractPlayreadyLicense(license) {
    return strToBytes(license);
}

/**
 * Gather the different way to get the license from webservices under binary depending of the CDM used
 * WIDEVINE,PLAYREADY and FAIRPLAY supported
 * @param license
 * @param cdmType
 * @returns The license as binary depending of the CDM
 */
function extractLicense(license, cdmType) {
    switch (cdmType) {
        case "playready":
            return extractPlayreadyLicense(license);
        case "widevine":
        default:
            return extractWidevineFairplayLicense(license);
    }
}

/*
export function getManifest(channel, userProfile, config, options) {
    const { deviceType, deviceInfo, maxCompatibleVideoOutput } = config;
    return {
        url: `${
            options?.lowLatencyMode ? channel.WSXUrlLL : channel.WSXUrl
        }${streamTokenFormatted}`,
        keySystems: getLiveKeySystems(channel.epgId, userProfile, config),
        // secret rx-player option to fix live manifest date
        referenceDateTime:
            config.referenceDateTime || Date.UTC(2013, 5, 1, 0, 0, 0, 0) / 1000,
        checkMediaSegmentIntegrity: config.checkMediaSegmentIntegrity,
        representationFilter: getRepresentationFilterString(
            deviceType,
            deviceInfo,
            maxCompatibleVideoOutput,
        ),
        ...(options?.lowLatencyMode &&
            options?.serverTimestamp &&
            options?.clientTime &&
            options?.offset < 5000 && {
                serverSyncInfos: {
                    serverTimestamp: Date.now() + options.offset,
                    clientTime: options.clientTime,
                },
            }),
    };
}

 */

export {
    getLiveKeySystems,
    DRMTypes,
    isEdge,
    isEdgeChromium,
    isFullscreen,
    Logger,
    isWindows
}


